import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=c46de09e&scoped=true"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"
import style0 from "./creation.vue?vue&type=style&index=0&id=c46de09e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46de09e",
  null
  
)

export default component.exports